import React from "react";

function Header() {
  return (
    <section id="header">
      <div className="header-top">
        <div className="container">
          <div className="name">
            <i className="fa fa-graduation-cap mr-1"></i> داده کاوان دوران
          </div>
        </div>
      </div>
    </section>
  );
}

export default Header;
